/**
 * Google Analytics page views.
 * gtag.js is already loaded and configured in public/index.html (send_page_view: false),
 * so there is no second script / ReactGA.initialize (that used to inject gtag.js again).
 */
export const trackPageView = (path = window.location.pathname + window.location.search) => {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};
